import { transformProps } from "motion-dom";
import { scaleCorrectors } from "../../projection/styles/scale-correction";
export function isForcedMotionValue(key, { layout, layoutId }) {
    return (transformProps.has(key) ||
        key.startsWith("origin") ||
        ((layout || layoutId !== undefined) &&
            (!!scaleCorrectors[key] || key === "opacity")));
}
//# sourceMappingURL=is-forced-motion-value.js.map